import { useState } from "react";
import { useHistory, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";
import httpClient from "../../custom-hooks/httpClient";
import LoginImageBanner from "../LoginImgBanner";
import logo from "../../images/kegow-color.png";

function Otp() {
  const history = useHistory();

  const phone_number = localStorage.getItem("phoneNumber");

  const [otp, setOtp] = useState("");
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

  const handleChange = (e) => {
    setOtp(e.target.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsVerifyingOtp(true);
    httpClient
      .post(`/auth`, { phone_number, otp })
      .then(({ status, data }) => {
        setIsVerifyingOtp(false);
        if (status === 200) {
          localStorage.setItem("tk", data.token);
          history.push("/security-pin");
        }
      })
      .catch((err) => {
        setIsVerifyingOtp(false);
        toast.error(
          err && err.response
            ? err.response.data.message
            : "Error Verifying OTP"
        );
      });
  };

  // Redirect to signup is there's no phone number
  if (!phone_number || !/^234[1-9]\d{9}/.test(phone_number)) {
    return <Redirect to="/signup" />;
  }

  return (
    <>
      <section className="login-page row min-vh-100 d-flex mt-6 mt-md-0 flex-row">
        <LoginImageBanner />

        <div className="d-flex col-12 align-items-center col-md-6">
          <div className="p-7 container me-md-4">
            <img
              className="keg-login-logo mb-6 mb-md-6"
              src={logo}
              alt="kegow-pic"
            />
            <h1 className="mb-0 fw-medium text-primary">OTP Confirmation</h1>
            <form className="mb-6" onSubmit={handleSubmit}>
              <div className="form-group mb-5">
                <label className="form-label" htmlFor="pin">
                  Confirm the OTP we sent
                </label>
                <input
                  type="password"
                  className="form-control form-control-user"
                  placeholder="e.g 000000"
                  onChange={handleChange}
                  maxLength="6"
                  required
                />
              </div>
              {isVerifyingOtp ? (
                <button className="btn w-100 btn-primary">
                  <Loader type="Oval" color="#fff" width={20} height={20} />
                </button>
              ) : (
                <button className="btn w-100 btn-primary" type="submit">
                  Next
                </button>
              )}
            </form>
          </div>
        </div>
      </section>
    </>
  );
}

export default Otp;
